import Image from "next/image";
import { cn } from "@/lib/utils";

export type BrowserMockupScreenshot = {
	title: string;
	imageUrl: string;
};

export default function BrowserMockup({
	screenshot,
	priority = false,
	compact = false,
	sizes = "(min-width: 1024px) 900px, (min-width: 640px) 78vw, 100vw",
	className,
	imageClassName,
}: {
	screenshot: BrowserMockupScreenshot;
	priority?: boolean;
	compact?: boolean;
	sizes?: string;
	className?: string;
	imageClassName?: string;
}) {
	return (
		<div
			className={cn(
				"w-full shrink-0 overflow-hidden rounded-lg border border-white/10 bg-[#14171d] shadow-[0_24px_70px_-24px_rgba(0,0,0,0.9)] sm:rounded-xl",
				className,
			)}
		>
			<div
				className={cn(
					"flex items-center border-b border-white/10 bg-[#1b1e26]",
					compact
						? "gap-1 px-2 py-1.5"
						: "gap-1 px-2.5 py-2 sm:gap-1.5 sm:px-3.5 sm:py-2.5",
				)}
			>
				<span
					aria-hidden="true"
					className={cn(
						"rounded-full bg-[#ff5f57]",
						compact ? "h-1.5 w-1.5" : "h-2 w-2 sm:h-2.5 sm:w-2.5",
					)}
				/>
				<span
					aria-hidden="true"
					className={cn(
						"rounded-full bg-[#febc2e]",
						compact ? "h-1.5 w-1.5" : "h-2 w-2 sm:h-2.5 sm:w-2.5",
					)}
				/>
				<span
					aria-hidden="true"
					className={cn(
						"rounded-full bg-[#28c840]",
						compact ? "h-1.5 w-1.5" : "h-2 w-2 sm:h-2.5 sm:w-2.5",
					)}
				/>
				<div
					className={cn(
						"min-w-0 flex-1 truncate bg-white/5 text-center text-zinc-500",
						compact
							? "ml-1 rounded px-2 py-0.5 text-[8px] leading-none"
							: "ml-1.5 rounded px-2 py-0.5 text-[9px] sm:ml-3 sm:rounded-md sm:px-3 sm:py-1 sm:text-[11px]",
					)}
				>
					{screenshot.title}
				</div>
			</div>
			<div className="relative aspect-[1440/763] w-full bg-[#0f1116]">
				<Image
					src={screenshot.imageUrl}
					alt={screenshot.title}
					fill
					priority={priority}
					className={cn("object-contain object-top", imageClassName)}
					sizes={sizes}
				/>
			</div>
		</div>
	);
}
